import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const useScrollToStart = () => {
  const startRef = useRef(null);
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  useEffect(() => {
    if (generalSettings.displaySpecificContent.display && startRef.current) {
      startRef.current.scrollIntoView();
    }
  }, [
    generalSettings.displaySpecificContent.display,
    startRef.current,
    generalSettings.displaySpecificContent.contentIndex,
  ]);

  return startRef;
};

export default useScrollToStart;
